module.exports = __webpack_public_path__ + "img/mozambique.bede3277.svg";